import React from "react";
import _ from "underscore";

import "./embeddedVideo.scss";

interface OwnProps {
  videoId: string;
  title?: string;
}

export const EmbeddedVideo = ({ videoId, title }: OwnProps) => (
  <div className="embedded-video">
    <iframe
      src={`https://player.vimeo.com/video/${videoId}?autoplay=1&app_id=122963&title=0&byline=false&portrait=0`}
      width="640"
      height="360"
      frameBorder="0"
      title={title || "An introduction to TravelLocal"}
    ></iframe>
  </div>
);
